export const responseStatusCode = {
    UNAUTHORIZED: 401,
};
